import React, { useState } from "react";
import Program, { EmptyProgram, EmptyPrograms } from "../types/Program";

type Props = {
  children: React.ReactNode;
};

type UniversityContextType = {
  programs: Array<Program>;
  selectedProgram: Program;

  setAllPrograms: (programs: Program[]) => void;
  setProgram: (program: Program) => void;

  [key: string]: any;
};

export const UniversityContext = React.createContext<UniversityContextType>({
  programs: EmptyPrograms,
  selectedProgram: EmptyProgram,
  setAllPrograms: () => {},
  setProgram: () => {},
});

const UniversityContextProvider = ({ children }: Props) => {
  const [programs, setPrograms] = useState<Program[]>(EmptyPrograms);
  const [selectedProgram, setSelectedProgram] = useState<Program>(EmptyProgram);

  const setAllPrograms = (programs: Program[]) => {
    setPrograms(programs);
  };

  const setProgram = (program: Program) => {
    setSelectedProgram(program);
  };

  return (
    <UniversityContext.Provider
      value={{ programs, selectedProgram, setAllPrograms, setProgram }}
    >
      {children}
    </UniversityContext.Provider>
  );
};

export default UniversityContextProvider;
